import { combineReducers } from 'redux';
import navReducer from './navReducer';
import headerReducer from "./headerReducer";
import dataReducer from './dataReducer';
import fleetReducer from './fleetReducer';
import soundReducer from './soundReducer';

const rootReducer = combineReducers({
    nav: navReducer,
    header: headerReducer,
    data: dataReducer,
    fleet: fleetReducer,
    sound: soundReducer
});

export default rootReducer;